import { z } from 'zod';

/**
 * 利用企業削除フォームの Zod スキーマファクトリ
 *
 * 共通フォーム（解約 / 誤登録 のモード切替なし）。
 * - type: 種別（解約 / 誤登録）必須
 * - reason: 削除理由（任意）
 * - clientName: 削除する利用企業名（必須・利用企業名 `name` と完全一致が必要）
 *
 * @param name 利用企業名（clientName の完全一致チェックに使用）
 */
export const createDeleteClientFormSchema = (name: string) =>
  z.object({
    /** 種別（解約 / 誤登録）必須 */
    type: z.enum(['churned', 'created_by_mistake'], {
      errorMap: () => ({ message: '種別を選択してください' }),
    }),
    /** 削除理由（任意） */
    reason: z.string().optional(),
    /**
     * 削除する利用企業名（必須・利用企業名と完全一致が必要）
     */
    clientName: z.string().refine(val => val === name, {
      message: '利用企業名と一致しません',
    }),
  });

export type DeleteClientFormValues = z.infer<ReturnType<typeof createDeleteClientFormSchema>>;
